/**
 * 异步加载脚本
 * @return {Promise}
 */
import track from './track';
import { getShareURlDocId, getDocIdRpmData} from './ClipperForRMP';
import { loadDownLoadStatus, loadProgressValue } from '../actions/sharepage';
import isFeedsFast from './isFeedsFast';
import { isLoadKuaiBao, getProfileId } from './PageConfigDataForShare';

const isFF = isFeedsFast() || false;
const _appPkgNameKuaibao = 'com.tencent.reading';
const _appDownloadUrlKuaibao = 'http://dldir1.qq.com/dlomg/chuanyue/kuaibao_9003954.apk';

const tbsProxyFactory = {
  _url: '',
  _appDownloadUrl: isFF ? 'https://mdc.html5.qq.com/directdown?app=qbspeed&channel=11707' : 'https://appchannel.html5.qq.com/directdown?app=qqbrowser&channel=11475',
  _appPkgName: isFF ? 'com.tencent.feedsfast' : 'com.tencent.mtt',
  _hashFunc(s) {
    if (s == null) {
      s = '';
    }
    let hash = 0;
    if (s.length === 0) {
      return hash;
    }
    for (let i = 0; i < s.length; i++) {
      const char = s.charCodeAt(i);
      hash = ((hash << 5) - hash) + char;
      hash &= hash; // Convert to 32bit integer
    }
    return hash;
  },
  getProgress() {
    let totalSize = 0;
    let downloadedSize = 0;
    try {
      totalSize = parseInt(window.tbs && window.tbs.download.getDownloadFileTotalSize({ url: this._appDownloadUrl }));
      downloadedSize = parseInt(window.tbs && window.tbs.download.getDownloadProgress({ url: this._appDownloadUrl }));
    } catch (error) {
      console.log('error', error);
    }
    if (totalSize === 0 || downloadedSize === 0) {
      return 0;
    }
    return Math.round(100 * downloadedSize / totalSize);
  },
  isDownloadError() {
    const status = window.tbs && window.tbs.download.getDownloadStatus({ url: this._appDownloadUrl });
    if (status === 'TASK_STATUS_FAILED' || status === 'TASK_STATUS_TIMEOUT') {
      if (status === 'TASK_STATUS_FAILED') {
        console.log('下载失败：downloadFailed');
      }
      if (status === 'TASK_STATUS_TIMEOUT') {
        console.log('下载超时：downloadTimeOut');
      }
      return true;
    }
    return false;
  },
  isDownloading() {
    const status = window.tbs && window.tbs.download.getDownloadStatus({ url: this._appDownloadUrl });
    if (status === 'TASK_STATUS_CREATED' || status === 'TASK_STATUS_STARTED' || status === 'TASK_STATUS_PROGRESS') {
      return true;
    }
    return false;
  },
  isDownloadCanceled() {
    const status = window.tbs && window.tbs.download.getDownloadStatus({ url: this._appDownloadUrl });
    if (status === 'TASK_STATUS_CANCELED') {
      return true;
    }
    return false;
  },
  runApp(pkgName, url) {
    pkgName = pkgName || this._appPkgName;
    url = url || (this._url || window.localStorage.getItem('URL_FOR_SHARE') || window.location.href);

    const docId = getShareURlDocId(url);
    const rmpData = getDocIdRpmData(docId);
    console.log(`点击文章的url：${url}`)
    console.log(`点击文章的docId：${docId}`)
    console.log(`点击文章的rmpData：${rmpData}`)

    let apkInfo = {
      packagename: pkgName,
      url,
      PosID: '9903',
      extraInfo: JSON.stringify({
        'sceneId': '1',
        'rmpData': rmpData
      })
    };

    // 拉新拉活快报
    if (isLoadKuaiBao()) {
      url = `qnreading://article_detail?nm=${docId}&from=liulanqi_share_imagetext&refer=liulanqi_share_imagetext`;
      apkInfo = {
        packagename: pkgName,
        url
      }
    }

    track({
      location: 'sharelp',
      action: 'click',
      object: 'sharelp_run_app',
      ch: getProfileId()
    });

    console.log('apkInfo', apkInfo)

    window.tbs && window.tbs.package.runApp(apkInfo);

  },
  isDownloaded() {
    return window.tbs && window.tbs.download.isFileDownloaded({ url: this._appDownloadUrl }) === 'FILE_HAS_DOWNLOADED';
  },
  isInstalled() {
    return window.tbs && window.tbs.package && window.tbs.package.isApkInstalled({ packagename: this._appPkgName }) === '1';
  },
  uploadBeacon(action) {
    console.log(`action:${action}`);
  },
  startDownload() {
    console.log('开始下载：invokeDownload');
    const status = window.tbs && window.tbs.download.getDownloadStatus({ url: this._appDownloadUrl });
    if (status === 'TASK_STATUS_CANCELED') {
      track({
        location: 'sharelp',
        action: 'tbsload',
        object: 'sharelp_resumedownloadQB',
        ch: getProfileId()
      });
      window.tbs && window.tbs.download.resumeDownload({ url: this._appDownloadUrl });
    } else if (status !== 'TASK_STATUS_CREATED' && status !== 'TASK_STATUS_STARTED' && status !== 'TASK_STATUS_PROGRESS') {
      const that = this;
      track({
        location: 'sharelp',
        action: 'tbsload',
        object: 'sharelp_startdownloadQB',
        ch: getProfileId()
      });
      window.tbs && window.tbs.download.startDownload({
        url: that._appDownloadUrl,
        filename: `${Math.abs(this._hashFunc(this._appDownloadUrl))}.apk`
      }, (opt) => {
      });
    }
  },
  cancelDownload() {
    track({
      location: 'sharelp',
      action: 'tbsload',
      object: 'sharelp_canceldownloadQB',
      ch: getProfileId()
    });
    window.tbs && window.tbs.download.pauseDownload({ url: this._appDownloadUrl });
  },
  startInstall() {
    if (window.tbs && window.tbs.download.installApp({ url: this._appDownloadUrl }) != 0) { // 不等于0说明文件可能已经损坏，需要重新下载
      console.log('手动点击触发安装失败：install:fail');
      track({
        location: 'sharelp',
        action: 'tbsload',
        object: 'sharelp_installedFailedQB',
        ch: getProfileId()
      });
    } else {
      tbsProxyFactory.listernIsCanRunApp();
      console.log('手动点击触发安装完成：install:success');
    }
  },
  // 监听是否调起QB
  listernIsCanRunApp() {
    let listernIsCanRunApp = null;
    listernIsCanRunApp = setInterval(() => {
      const newState = tbsProxyFactory._getState();
      if (newState === 'installed') {
        clearInterval(listernIsCanRunApp);
        track({
          location: 'sharelp',
          action: 'tbsload',
          object: 'sharelp_installedQB',
          ch: getProfileId()
        });
        console.log('完成安装：sharelp_installedQB');
        tbsProxyFactory.runApp();
      }
    }, 1000);
  },
  _getState() {
    if (this.isInstalled()) {
      return 'installed';
    } else if (this.isDownloading()) {
      return 'downloading';
    } else if (this.isDownloadCanceled()) {
      return 'downloadcanceled';
    } else if (this.isDownloaded()) {
      return 'downloaded';
    } else if (this.isDownloadError()) {
      return 'downloaderror';
    }
    return 'notdownloaded';
  }
};



let intervalTime = null;
function downloadingUpdate(dispatchFunc) {
  // 监听是否下载完成
  intervalTime = setInterval(() => {
    const newState = tbsProxyFactory._getState();
    const progress = tbsProxyFactory.getProgress();
    dispatchFunc(loadDownLoadStatus(newState)); // 更新下载状态
    dispatchFunc(loadProgressValue(progress)); // 更新进度
    console.log(`newState：${newState}；progress：${progress}`)
    if (newState === 'downloaded') {
      clearInterval(intervalTime);
      track({
        location: 'sharelp',
        action: 'tbsload',
        object: 'sharelp_downloadedQB',
        ch: getProfileId()
      });
      console.log('完成下载：sharevideo_downloadedQB');
      tbsProxyFactory.startInstall();
    }
  }, 1000);
  // 监听是否调起QB
  // tbsProxyFactory.listernIsCanRunApp();
}

export function startQbDownLoadForShare(dispatchFunc, url) {

  if(isLoadKuaiBao()) {
    tbsProxyFactory._appPkgName = _appPkgNameKuaibao;
    tbsProxyFactory._appDownloadUrl = _appDownloadUrlKuaibao;
  }

  if (url) {
    window.localStorage.setItem('URL_FOR_SHARE', url);
  }
  const newState = tbsProxyFactory._getState();
  if (newState === 'downloading') { // 下载中
    // 下载中不做任何处理
  } else if (newState === 'downloadcanceled') { // 取消下载时，恢复下载
    tbsProxyFactory.startDownload();
    downloadingUpdate(dispatchFunc);
  } else if (newState === 'downloaded') { // 下载完成，进行安装
    tbsProxyFactory.startInstall();
    dispatchFunc(loadDownLoadStatus(newState));
  } else if (newState === 'installed') { // 安装完成，进行启动

    tbsProxyFactory.runApp();
    dispatchFunc(loadDownLoadStatus(newState));
  } else { //  未下载或者下载失败，则继续下载
    tbsProxyFactory.startDownload();
    downloadingUpdate(dispatchFunc);
  }
}

export function cancelQbDownLoadForShare(dispatchFunc) {
  tbsProxyFactory.cancelDownload();
  dispatchFunc(loadDownLoadStatus('downloadcanceled')); // 改为暂停状态
  clearInterval(intervalTime);
}

export function isInstalled() {

  if(isLoadKuaiBao()) {
    tbsProxyFactory._appPkgName = _appPkgNameKuaibao;
    tbsProxyFactory._appDownloadUrl = _appDownloadUrlKuaibao;
  }

  return tbsProxyFactory.isInstalled();
}

export function tbsRunApp() {

  if(isLoadKuaiBao()) {
    tbsProxyFactory._appPkgName = _appPkgNameKuaibao;
    tbsProxyFactory._appDownloadUrl = _appDownloadUrlKuaibao;
  }

  return tbsProxyFactory.runApp();
}
